const FieldChangeSources = {
  DocumentIntelligence: 1,
  1: 'DocumentIntelligence'
};
export default FieldChangeSources;
